// events
export const stepPayloadDefaults = {
  page_section: 'Tests',
  dossier_name: 'Hypotheek',
  dossier_theme: 'Geld & Verzekering',
  page_type: 'Advies',
  form_type: 'Advies',
};

const maxMortgageStepPayloadMap = {
  inkomen: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Inkomen',
    form_step: '1',
    form_step_name: 'Inkomen',
    form_status: ['start'],
    form_name: 'Maximaal Lenen V2',
  },
  segmentatie: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Segmentatie',
    form_step: '2',
    form_step_name: 'Segmentatie',
    form_status: ['mid', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
  vermogen: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Eigen Middelen',
    form_step: '3',
    form_step_name: 'Eigen Middelen',
    form_status: ['mid', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
  woning: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Woning',
    form_step: '4',
    form_step_name: 'Woning',
    form_status: ['mid', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
  hypotheek: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Hypotheek',
    form_step: '5',
    form_step_name: 'Hypotheek',
    form_status: ['mid', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
  queue: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Uitrekenen',
    form_step: '6',
    form_step_name: 'Uitrekenen',
    form_status: ['mid', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
  feedback: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Feedback',
    form_step: '7',
    form_step_name: 'Feedback',
    form_status: ['end', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
};

const refinanceStepPayloadMap = {
  hypotheek: {
    page_name: 'Hypotheek:Advies:Oversluiten:Hypotheek',
    form_step: '1',
    form_step_name: 'Hypotheek',
    form_status: ['start'],
    form_name: 'Oversluiten',
  },
  woning: {
    page_name: 'Hypotheek:Advies:Oversluiten:Woning',
    form_step: '2',
    form_step_name: 'Woning',
    form_status: ['mid', 'success'],
    form_name: 'Oversluiten',
  },
  leningdelen: {
    page_name: 'Hypotheek:Advies:Oversluiten:Leningdelen',
    form_step: '3',
    form_step_name: 'Leningdelen',
    form_status: ['mid', 'success'],
    form_name: 'Oversluiten',
  },
  inkomen: {
    page_name: 'Hypotheek:Advies:Oversluiten:Inkomen',
    form_step: '4',
    form_step_name: 'Inkomen',
    form_status: ['mid', 'success'],
    form_name: 'Oversluiten',
  },
  renteverwachting: {
    page_name: 'Hypotheek:Advies:Oversluiten:Renteverwachting',
    form_step: '5',
    form_step_name: 'Renteverwachting',
    form_status: ['mid', 'success'],
    form_name: 'Oversluiten',
  },
  queue: {
    page_name: 'Hypotheek:Advies:Oversluiten:Uitrekenen',
    form_step: '6',
    form_step_name: 'Uitrekenen',
    form_status: ['mid', 'success'],
    form_name: 'Oversluiten',
  },
  feedback: {
    page_name: 'Hypotheek:Advies:Oversluiten:Feedback',
    form_step: '7',
    form_step_name: 'Feedback',
    form_status: ['end', 'success'],
    form_name: 'Oversluiten',
  },
};

const monthlyChargePayloadMap = {
  'form': {
    page_name: 'Hypotheek:Advies:Maandlasten:Je gegevens',
    form_name: 'Maandlasten',
    form_step: '1',
    form_step_name: 'Je gegevens',
    form_status: ['start'],
  },
  'feedback': {
    page_name: 'Hypotheek:Advies:Maandlasten:Resultaten',
    form_name: 'Maandlasten',
    form_step: '2',
    form_step_name: 'Resultaten',
    form_status: ['mid', 'success'],
  },
  'interest-raise': {
    page_name: 'Hypotheek:Advies:Maandlasten:Wat als de rente stijgt',
    form_name: 'Maandlasten',
    form_step: '2a',
    form_step_name: 'Wat als de rente stijgt',
    form_status: [],
  },
};

const toolStepPayloadMap = {
  max_mortgage: maxMortgageStepPayloadMap,
  refinance: refinanceStepPayloadMap,
  monthly_charge: monthlyChargePayloadMap,
};

/**
 * Returns specific step payload
 *
 * @param {Object} event payload with tool & step property
 * @return {Object} step payload
 */
export function getStepPayload({ toolName, to, step }) {
  const payload = toolStepPayloadMap[toolName]?.[to || step];

  if (!payload)
    return null;

  return { ...payload, ...stepPayloadDefaults };
}
